import { Menu } from '@app/interfaces/sys/menu';
import { environment } from '@env/environment';

const menus: Menu[] = [
    {
        key: 'myTask',
        text: 'Dashboard',
        link: '/task/my',
        icon: { type: 'icon', value: 'dashboard' },
        permissions: ['My Task View', 'Cell Status View', 'Radio Power View', 'Available Chamber View', 'Available Tester View'],
        categoryKey: 'home',
    },
    {
        key: 'labTopology',
        text: 'Lab Topology',
        link: '/lab-topology',
        icon: { type: 'icon', value: 'radar-chart' },
        permissions: ['Lab Topology View'],
        categoryKey: 'home'
    },


//projectManagement

    {
        key: 'kanbanBoard',
        text: 'Kanban Board',
        link: '/kanban-board',
        icon: { type: 'icon', value: 'svg:kanban' },
        permissions: ['Kanban Board View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'utilizationTracker',
        text: 'Utilization Tracker',
        link: '/utilization-tracker',
        icon: { type: 'icon', value: 'svg:timeline' },
        permissions: ['Utilization Tracker View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'alert',
        text: 'Alerts',
        link: '/alert',
        icon: { type: 'icon', value: 'insert-row-below' },
        permissions: ['Alert View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'project',
        text: 'Project',
        link: '/project',
        icon: { type: 'icon', value: 'fork' },
        permissions: ['Project View', 'Project Draft View', 'Project Archived View', 'Project Completed View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'projectGroup',
        text: 'Project Group',
        link: '/project-group',
        icon: { type: 'icon', value: 'group' },
        permissions: ['Project Group View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'utilization',
        text: 'Utilization',
        link: '/utilization',
        icon: { type: 'icon', value: 'bar-chart' },
        permissions: ['Utilization View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'ticket',
        text: 'Ticket',
        link: '/ticket',
        icon: { type: 'icon', value: 'svg:ticket' },
        permissions: ['Ticket View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'resourceRequest',
        text: 'Resource Request',
        link: '/resource-request/pending',
        icon: { type: 'icon', value: 'svg:approve' },
        permissions: ['Resource Request View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'resourceReservation',
        text: 'Resource Reservation',
        link: '/resource-reservation',
        icon: { type: 'icon', value: 'appstore-add' },
        permissions: ['Resource Reservation Chamber View', 'Resource Reservation Radio View', 'Resource Reservation Engineer View'],
        categoryKey: 'projectManagement'
    },
    {
        key: 'calendar',
        text: 'Calendar',
        link: '/calendar',
        icon: { type: 'icon', value: 'schedule' },
        permissions: ['Calendar View'],
        categoryKey: 'projectManagement'
    },

    //labManagement
    {
        key: 'chamberManagement',
        text: 'Resource Management ',
        link: '/chamber-management',
        icon: { type: 'icon', value: 'appstore' },
        permissions: ['Chamber View', 'Radio View', 'Matrix View', 'Scanner View', 'Base Station View', 'UE View', 'Physical Server View',
            'Server Accessory View', 'Test Equipment View', 'SFP View', 'Switch Router View', 'Test SIM View',
            'Software Tools View', 'BBU View', 'BBU Accessories View', 'RF Accessory View', 'RF Switch Splitter View', 'Attenuator View',
            'GPS Amplifier View', 'Shield Chamber Box View', 'Rack View', 'Cloud Cluster Platform View', 'CNF(VNF) View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'floorMap',
        text: 'Floor Map',
        link: '/floor-map',
        icon: { type: 'icon', value: 'svg:floor-map' },
        permissions: ['Floor Map View'],
        categoryKey: 'labManagement'
    },
    {
        key: 'resourceTracking',
        text: 'Resource Tracking',
        link: '/resource-tracking/location',
        icon: { type: 'icon', value: 'svg:track' },
        permissions: ['Resource Location View', 'Resource Connection View', 'Room View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'location',
        text: 'Resource Location',
        link: '/location',
        icon: { type: 'icon', value: 'svg:location' },
        permissions: ['Location View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'teams',
        text: 'Teams',
        link: '/team/view',
        icon: { type: 'icon', value: 'svg:team' },
        permissions: ['Team View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'teamMember',
        text: 'Team Member',
        link: '/team/list/all',
        icon: { type: 'icon', value: 'user' },
        permissions: ['Team Member View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'document',
        text: 'Document',
        link: '/document',
        icon: { type: 'icon', value: 'insert-row-below' },
        permissions: ['Document View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'labConfig',
        text: 'Lab Space Config',
        link: '/lab-config',
        icon: { type: 'icon', value: 'svg:lab-config' },
        permissions: ['Lab Management View', 'Room Storage Template View', 'Resource Group View'],
        categoryKey: 'labManagement',
    },
    {
        key: 'labMonitor',
        text: 'Lab Monitor',
        link: '/lab-monitor',
        icon: { type: 'icon', value: 'control' },
        permissions: ['Lab Monitor View'],
        categoryKey: 'labManagement'
    },
    {
        key: 'repositoryManagement',
        text: 'Repository Management',
        link: '/repository-management',
        icon: { type: 'icon', value: 'svg:repository' },
        permissions: ['Repository Management View'],
        categoryKey: 'labManagement',
    },


    //testOrchestration
    {
        key: 'advancedMobility',
        text: 'Advanced Mobility',
        link: '/advanced-mobility',
        icon: { type: 'icon', value: 'desktop' },
        permissions: ['Advanced Mobility View'],
        categoryKey: 'testOrchestration'
    },
    {
        key: 'radioTesting',
        text: 'Device Control ',
        link: '/radio-testing',
        icon: { type: 'icon', value: 'sliders' },
        permissions: ['Radio Testing View'],
        categoryKey: 'testOrchestration'
    },
    {
        key: 'matrixMonitor',
        text: 'Attenuation Monitor',
        link: '/matrix-monitor',
        icon: { type: 'icon', value: 'sliders' },
        permissions: ['Matrix Monitor View'],
        categoryKey: 'testOrchestration'
    },
    {
        key: 'simulatorManagement',
        text: 'Simulator Management',
        link: '/simulator',
        icon: { type: 'icon', value: 'control' },
        permissions: ['Simulator View'],
        categoryKey: 'testOrchestration'
    },

    // system menu
    {
        key: 'role',
        text: 'Role',
        link: '/role',
        icon: { type: 'icon', value: 'solution' },
        permissions: ['Role View'],
        categoryKey: 'system'
    },
    {
        key: 'accounts',
        text: 'Accounts',
        link: '/accounts',
        icon: { type: 'icon', value: 'usergroup-add' },
        permissions: ['Account View'],
        categoryKey: 'system'
    },
    {
        key: 'license',
        text: 'License',
        link: '/license',
        icon: { type: 'icon', value: 'desktop' },
        permissions: ['License View'],
        categoryKey: 'system'
    },
    {
        key: 'systemConfig',
        text: 'System Config',
        link: '/system-config/tab',
        icon: { type: 'icon', value: 'svg:config' },
        permissions: ['Customized Resources View', 'Approval Settings View', 'Task Template View', 'Resources View', 'Resource Template View'],
        categoryKey: 'system'
    },
    {
        key: 'systemLog',
        text: 'System Log',
        link: '/system-log',
        icon: { type: 'icon', value: 'book' },
        permissions: ['System Log View'],
        categoryKey: 'system'
    },
    {
        key: 'auditLog',
        text: 'Audit Log',
        link: '/audit-log',
        icon: { type: 'icon', value: 'container' },
        permissions: ['Audit Log View'],
        categoryKey: 'system'
    },
    {
        key: 'notification',
        text: 'Notification',
        link: '/notification',
        icon: { type: 'icon', value: 'message' },
        permissions: ['Notification View'],
        categoryKey: 'system'
    },


    // {
    //     key: 'inventory',
    //     text: 'Inventory',
    //     link: '/inventory',
    //     icon: { type: 'icon', value: 'database' },
    //     permissions: ['Inventory View']
    // },
];

let userPermissions: string[] = [];
let userRoleNames: string[] = [];

const setMenu = (currentMenu: Menu[]): void => {
    const enablePages: string[] = environment.enablePages || [];
    currentMenu.forEach((item: Menu) => {
        if (item.children && item.children.length > 0) {
            setMenu(item.children);
        }
        if (item.children && item.children.length === 0) {
            item.hide = true;
            return;
        }

        if (item.key && !enablePages.includes(item.key)) {
            item.hide = true;
            return;
        }

        if (!item.permissions || item.permissions.length === 0) {
            item.hide = false;
            return;
        }

        if (item.permissions.some((permission: string) => userPermissions.includes(permission))) {
            item.hide = false;
            return;
        }
        item.hide = true;
    });
};

export function getMenu(permissions: string[], roleNames: string[] = []): Menu[] {
    userPermissions = [...permissions];
    userRoleNames = [...roleNames];
    setMenu(menus);
    return menus;
}

